import { Formatter } from '@bingads-webui/listener';

export class ConsoleFormatter extends Formatter {
  format(log) {
    const logMessage = JSON.stringify(log.message);

    return logMessage;
  }
}
